import React from 'react';
import { useFormContext } from 'react-hook-form';
const HealthcarePOA = () => {
  const {
    register
  } = useFormContext();
  return <div className="space-y-8" data-id="element-528">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-529">
        <p className="text-slate-700" data-id="element-530">
          A Power of Attorney for Personal Care gives someone else the legal
          authority to make decisions about your healthcare, housing, and other
          personal matters if you become unable to make these decisions
          yourself.
        </p>
      </div>
      {/* Primary Attorney */}
      <div className="space-y-4" data-id="element-531">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-532">
          Primary Attorney for Personal Care
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-533">
          <div data-id="element-534">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-535">
              Name
              <span className="text-red-500 ml-1" data-id="element-536">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter attorney's name" {...register('healthcarePOA.primary.name')} data-id="element-537" />
          </div>
          <div data-id="element-538">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-539">
              Relationship
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register('healthcarePOA.primary.relationship')} data-id="element-540" />
          </div>
          <div data-id="element-541">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-542">
              Phone Number
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('healthcarePOA.primary.phone')} data-id="element-543" />
          </div>
        </div>
        <div data-id="element-544">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-545">
            Address
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter attorney's address" {...register('healthcarePOA.primary.address')} data-id="element-546" />
        </div>
      </div>
      {/* Alternate Attorney */}
      <div className="space-y-4" data-id="element-547">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-548">
          Alternate Attorney for Personal Care
        </h3>
        <p className="text-sm text-slate-600 mb-4" data-id="element-549">
          This person will act if your primary attorney is unable or unwilling
          to act.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-550">
          <div data-id="element-551">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-552">Name</label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate attorney's name" {...register('healthcarePOA.alternate.name')} data-id="element-553" />
          </div>
          <div data-id="element-554">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-555">
              Relationship
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register('healthcarePOA.alternate.relationship')} data-id="element-556" />
          </div>
          <div data-id="element-557">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-558">
              Phone Number
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('healthcarePOA.alternate.phone')} data-id="element-559" />
          </div>
        </div>
        <div data-id="element-560">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-561">
            Address
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter alternate attorney's address" {...register('healthcarePOA.alternate.address')} data-id="element-562" />
        </div>
      </div>
      {/* End of Life Wishes */}
      <div className="space-y-4" data-id="element-563">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-564">
          End of Life Wishes
        </h3>
        <div data-id="element-565">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-566">
            Do you have specific end of life wishes?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-567">
            <label className="inline-flex items-center" data-id="element-568">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('healthcarePOA.endOfLifeWishes.exists')} data-id="element-569" />
              <span className="ml-2" data-id="element-570">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-571">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('healthcarePOA.endOfLifeWishes.exists')} data-id="element-572" />
              <span className="ml-2" data-id="element-573">No</span>
            </label>
          </div>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Describe your end of life wishes (e.g., life support preferences, organ donation, etc.)" {...register('healthcarePOA.endOfLifeWishes.details')} data-id="element-574" />
        </div>
      </div>
    </div>;
};
export default HealthcarePOA;